import(/* webpackMode: "eager" */ "__barrel_optimize__?names=message!=!/app/node_modules/antd/es/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/(new-pages)/(new-job)/[lang]/job/[jobId]/closedJob.tsx");
;
import(/* webpackMode: "eager" */ "/app/app/(new-pages)/(new-job)/[lang]/job/[jobId]/jobTransProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/(new-pages)/(new-job)/[lang]/job/[jobId]/JobTransWrapped.mobile.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/(new-pages)/(new-job)/[lang]/job/[jobId]/JobTransWrapped.pc.tsx");
;
import(/* webpackMode: "eager" */ "/app/app/(new-pages)/(new-job)/[lang]/job/[jobId]/page.pc.module.scss");
;
import(/* webpackMode: "eager" */ "/app/app/(new-pages)/(new-job)/[lang]/job/[jobId]/page.mobile.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/(new-pages)/(new-job)/[lang]/job/[jobId]/utm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/providers/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/HamburgerMenu/HamburgerMenu.tsx");
